import { render, staticRenderFns } from "./category-pill.vue?vue&type=template&id=2f606ec2&"
import script from "./category-pill.vue?vue&type=script&lang=js&"
export * from "./category-pill.vue?vue&type=script&lang=js&"
import style0 from "./category-pill.vue?vue&type=style&index=0&id=2f606ec2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports